<span
  class="icon-button"
  [class.with-padding]="withPadding"
  [attr.e2e-attr]="e2eAttr"
  (click)="onClick()"
>
  <i
    [class]="icon"
  ></i>
</span>
